import { FC } from "react";

import {
  FETCH_RIDE_NEARBY_EXCLUDED_STATUSES,
  IRideDto,
  useSystemParams,
} from "@ryde/shared";

import { RideNearbyNoSearch, RidesNearbyFunnel } from "../../../common";

interface ICellMultiIconRidesNearBy {
  rideDto: IRideDto;
}

export const CellMultiIconRidesNearBy: FC<ICellMultiIconRidesNearBy> = ({
  rideDto,
}) => {
  const { disableNearByFeature } = useSystemParams();
  const { id, status } = rideDto;

  const isNearByDisabled = disableNearByFeature ?? false;
  const shouldFetchNearby =
    !isNearByDisabled && !FETCH_RIDE_NEARBY_EXCLUDED_STATUSES.includes(status);
  return (
    <>
      {!shouldFetchNearby && <RideNearbyNoSearch />}
      {shouldFetchNearby && <RidesNearbyFunnel rideId={id} />}
    </>
  );
};
